// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E8Nmz","title":"styles_title__P47mx"};